import { render, staticRenderFns } from "./CollectionsConditionsCatalogueManualTags.vue?vue&type=template&id=4af2ea3b&scoped=true"
import script from "./CollectionsConditionsCatalogueManualTags.vue?vue&type=script&lang=js"
export * from "./CollectionsConditionsCatalogueManualTags.vue?vue&type=script&lang=js"
import style0 from "./CollectionsConditionsCatalogueManualTags.vue?vue&type=style&index=0&id=4af2ea3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2ea3b",
  null
  
)

export default component.exports